class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
    this.giftTypes = ['gift','sample'];
    this.giftTypes.forEach(type => this.wcCheckGiftEligability(type));
    this.wcPreventEnterKeySubmit();
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  /*
  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }
  */

  onChange(event) {
    if(event.target.className == 'giftwrap-prop'){
      this.addItemGiftwrap(event.target.dataset.index, event.target.checked, event);
    }else{
      this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
    }
  }

  addItemGiftwrap(line, value, event) {
    var wrapit = 'No'
    if(value == true){
      wrapit = 'Yes'
    }
    const body = JSON.stringify({
      line,
      'properties': { '_gift_wrap': wrapit },
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);
    [...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        let currentTarget = event.target.name;
        let currentLabel = document.querySelector('label[for="'+ currentTarget +'"]');
        let currentCTA = currentLabel.innerText;
        let addCTA = currentLabel.dataset.add;
        let removeCTA = currentLabel.dataset.remove;

        if(currentCTA == addCTA){
          currentLabel.innerText = removeCTA;
        }else{
          currentLabel.innerText = addCTA;
        }
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
    });
  }



  onCartUpdate() {
    fetch(`${routes.cart_url}?section_id=cart-drawer`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const sourceQty = html.querySelector('.cart-drawer .drawer__inner');
        const targetQty = document.querySelector('#shopify-section-cart-drawer cart-drawer #CartDrawer.cart-drawer .drawer__inner')
        targetQty.innerHTML = sourceQty.innerHTML;
      })
      .catch(e => {
        console.error(e);
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents'
      }
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));

        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        }
        publish(PUB_SUB_EVENTS.cartUpdate, {source: 'cart-items'});
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
      const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
      lineItemError
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          quantityElement.value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }

  wcCheckGiftEligability(type) {

    this.wrapperClass = type == 'sample' ? ".wc-sample__container" : ".wc-gwtp__container";
    let giftProgressBar = document.querySelector(this.wrapperClass + ' #wc-gwp-progress-bar');

    if(giftProgressBar){

      let cartGiftTotal = parseFloat(this.dataset.wcCartTotal);
      let nextGiftThreshold = parseFloat(giftProgressBar.dataset.nextthreshold);
      let currentGiftThreshold = parseFloat(giftProgressBar.dataset.currentthreshold);
      let nextGiftThresholdCheck = parseFloat(nextGiftThreshold) * 100;
      let allowedGifts = type == 'sample' ? parseFloat(giftProgressBar.dataset.totalsamples) : parseFloat(giftProgressBar.dataset.totalgwp);

      this.giftItemWrapper = document.querySelector(this.wrapperClass);
      this.giftItemList = this.giftItemWrapper.querySelector('ul');
      this.giftItems = this.giftItemWrapper.querySelectorAll('.wc-gwp-gift--qualifies');
      this.giftItemsEligible = this.giftItemWrapper.querySelectorAll('.gift-' + nextGiftThreshold + ':not(.wc-gwp-gift--removed)');
      this.giftItemsNotEligible = this.giftItemWrapper.querySelectorAll('.wc-gwp-gift.wc-gwp-gift--qualifies:not(.gift-' + nextGiftThreshold +')');
      this.giftItemsCurrent = this.giftItemWrapper.querySelector(' .wc-gwp-gift--current');
      this.giftQualifiesHeader = this.giftItemWrapper.querySelector('.wc-progress-bar-container__message--qualifies');
      this.giftAddedHeader = this.giftItemWrapper.querySelector('.wc-progress-bar-container__message--added');
      this.giftRemoveButtons = this.querySelectorAll('cart-remove-button[data-wc-type="'+ type +'"]');
      this.giftTrueItems = document.querySelectorAll('.drawer__cart-items-wrapper .wc-cart-item--gift-item');

      // Manually remove ineligable gift items from cart
      const allGiftItems = this.querySelectorAll('gwtp-gift-item');
      allGiftItems.forEach(giftItem => {
        const cartTotal = parseFloat(this.dataset.cartTotal);
        const itemGiftThreshold = parseFloat(giftItem.dataset.threshold) * 100;
        if (cartTotal < itemGiftThreshold) {
          const giftItemId = giftItem.dataset.variantId;
          const giftCartItemRemove = document.querySelector(`[data-gift-product-id="${giftItemId}"]`);
          if (giftCartItemRemove) giftCartItemRemove.click(); // Could ammend wih better removal method
        }
      });

      if (this.giftItemList.getElementsByTagName('li').length === 0){
        this.giftItemWrapper.classList.add('hidden');
      }

      this.giftTrueItems.forEach(giftTrueItem => {
        giftTrueItem.querySelector('quantity-input.quantity')?.remove();
      });

      if (this.giftItemsCurrent){

        if(allowedGifts > this.giftRemoveButtons.length){
          //pick more
        }else{
          this.giftQualifiesHeader.classList.add('hidden');
          this.giftAddedHeader.classList.remove('hidden');
          this.giftItemsCurrent.classList.remove('hidden');

          this.giftItems.forEach(giftItem => {

            let itemGiftThreshold = parseFloat(giftItem.querySelector('gwtp-gift-item.cart-item').dataset.threshold);
            let currentItemGiftThreshold = parseFloat(this.giftItemsCurrent.querySelector('gwtp-gift-item.cart-item').dataset.threshold);

            if(itemGiftThreshold >= nextGiftThreshold && currentItemGiftThreshold < nextGiftThreshold){

              let itemToRemove = this.giftItemsCurrent.querySelector('.wc-fake-quantity .quantity__button label').getAttribute('for');
              let itemToRemoveButton = document.getElementById(itemToRemove).closest('cart-remove-button');

              let updateQuantityArgs = {
                line: itemToRemoveButton.dataset.index,
                quantity: 0,
                name: itemToRemoveButton.getAttribute('name'),
                key: itemToRemoveButton.dataset.key
              }
              this.updateQuantity(updateQuantityArgs);

            }else{
              giftItem.classList.add('hidden');
              giftItem.querySelector('.product-form')?.remove();
            }
            
          });

          /*
          this.giftItemsEligible.forEach(giftItem => {
              //giftItem.querySelector('.product-form')?.remove();
          });
          */

        }

      }else{
        this.giftQualifiesHeader.classList.remove('hidden');
        this.giftAddedHeader.classList.add('hidden');
      }

      this.giftItemsEligible.forEach(giftItem => {
        giftItem.classList.remove('hidden');
      });


      this.giftItemsNotEligible.forEach(giftItem => {

        let itemGiftThreshold = parseFloat(giftItem.querySelector('gwtp-gift-item.cart-item').dataset.threshold);

        if(itemGiftThreshold > nextGiftThreshold){
          giftItem.querySelector('.product-form')?.remove();
          giftItem.querySelector('.pseudo-product-form')?.classList.remove('hidden');
        }

        if(cartGiftTotal > currentGiftThreshold){
          if((itemGiftThreshold < nextGiftThreshold) && (itemGiftThreshold > currentGiftThreshold)){
            giftItem.classList.remove('hidden');
          }else{
            if(itemGiftThreshold < currentGiftThreshold){
              giftItem.classList.add('hidden');
              giftItem.querySelector('.product-form')?.remove();
            }
          }
        }

        if((cartGiftTotal >= nextGiftThresholdCheck) && (itemGiftThreshold < nextGiftThreshold)){
            giftItem.classList.add('hidden');
            giftItem.querySelector('.product-form')?.remove();
        }

      });

      this.giftRemoveButtons.forEach(removeButton => {
        const giftThreshold = parseFloat(removeButton.dataset.wcThreshold) * 100;

        let updateQuantityArgs = {
          line: removeButton.dataset.index,
          quantity: 0,
          name: removeButton.getAttribute('name'),
          key: removeButton.dataset.key
        }

        if (cartGiftTotal < giftThreshold) {
          this.updateQuantity(updateQuantityArgs);
        }
        if (giftThreshold > nextGiftThresholdCheck){
          this.updateQuantity(updateQuantityArgs);
        }
      });

      if(this.giftRemoveButtons.length > allowedGifts){
        this.giftRemoveButtons.forEach(removeButton => {
          let updateQuantityArgs = {
            line: removeButton.dataset.index,
            quantity: 0,
            name: removeButton.getAttribute('name'),
            key: removeButton.dataset.key
          }
          this.updateQuantity(updateQuantityArgs);
        });
      }

    }

  }

  wcPreventEnterKeySubmit() {
    const quantityInputs = this.querySelectorAll('.quantity__input');
    quantityInputs.forEach(input => {
      input.addEventListener('keypress', (event) => {
        if (event.key === 'Enter') event.preventDefault();
      });
    });
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();

    this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
    }, ON_CHANGE_DEBOUNCE_TIMER))
    }
  });
};

class CartDrawer extends Drawer {
  connectedCallback() {
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      document.querySelector('mobile-menu').mobilemenuHide();
      document.body.classList.add('drawer--isActive');
      this.classList.add('animate', 'active');
    });

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    setTimeout(() => {
      document.body.classList.remove('drawer--isActive');
    }, 300)
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}
customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
